import axios from 'axios'
import md5 from 'md5'
import encipher from '@/util/mySEC'

// axios.defaults.baseURL = '/api'
// axios.defaults.baseURL = 'http://page.5423wan.com/'
axios.defaults.baseURL = 'https://pagetest.llmaitengff.com/'
axios.defaults.timeout = 10000
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.withCredentials = true;
axios.interceptors.response.use(
  function (response) {
    // 响应数据处理
    if (response.data.state) {
      if (response.data.state == -1) {
        let url =
          window.location.origin + '/#/' + getParams(JSON.parse(localStorage.getItem('href-url')))
        localStorage.removeItem('nsjkdjc==')
        window.location.href = url
        window.location.reload()
      }
    }
    return response
  },
  function (error) {
    // 响应错误处理
    return Promise.reject(error)
  }
)

// 定义排序方法
function sortObjByKey(obj) {
  // 获取原对象集的key值赋给keys
  const keys = Object.keys(obj).sort()
  // 定义一个新的对象newObj，遍历keys并将每个key值添加到newObj，根据key匹配原对象集obj对应的key值
  let newObj = {}
  for (let i = 0; i < keys.length; i++) {
    const index = keys[i]
    newObj[index] = obj[index]
  }
  // 返回一个新的对象newObj（与原对象的区别：值为0或undefined的键值对，值变为空字符串）
  return newObj
}
// 将提交参数转化为FormData格式
export function getFormData(data) {
  let params = new FormData()
  Object.keys(data).forEach((key) => {
    params.append(key, data[key])
  })
  return params
}
function getParams(data) {
  const keys = Object.keys(data).sort()
  let urlParams = '?'
  for (let i = 0; i < keys.length; i++) {
    const index = keys[i]
    if (i == keys.length) {
      urlParams = urlParams + index + '=' + encodeURIComponent(data[index])
    } else {
      urlParams = urlParams + index + '=' + encodeURIComponent(data[index]) + '&'
    }
  }
  return urlParams
}
function getParamsSpecial(data) {
  const keys = Object.keys(data).sort()
  let urlParams = '&'
  for (let i = 0; i < keys.length; i++) {
    const index = keys[i]
    if (i == keys.length) {
      urlParams = urlParams + index + '=' + encodeURIComponent(data[index])
    } else {
      urlParams = urlParams + index + '=' + encodeURIComponent(data[index]) + '&'
    }
  }
  return urlParams
}

export function getReqData(data) {
  // 获取时间戳并转为字符串
  data.language = 2
  data.time = parseInt(Date.parse(new Date()) / 1000).toString()
  if (!data.duid && localStorage.getItem('initdevice==')) {
    data.duid = JSON.parse(encipher.des_decrypt(localStorage.getItem('initdevice=='))).duid
  }
  let reqData = sortObjByKey(data)
  // reqData.duid = localStorage.getItem('browserId');
  // 遍历reqData，去除sign用新变量tmpStr接
  let tmpStr = ''
  for (const key in reqData) {
    let tmp = ''
    if (key !== 'sign' && key !== 'file' && key !== 'comment' && key !== 'content') {
      if (reqData[key]) {
        tmp = reqData[key]
      } else {
        reqData[key] = ''
      }
      tmpStr += key + '=' + tmp + '&'
    }
  }
  tmpStr = tmpStr.substr(0, tmpStr.length - 1) + 'Jp8vQOYckhhta20221121'
  reqData.sign = md5(tmpStr)
  return reqData
  // return getFormData(reqData);
}
export function getReqDataNoToken(data) {
  // 获取时间戳并转为字符串
  data.language = 2
  data.time = parseInt(Date.parse(new Date()) / 1000).toString()
  if (!data.duid && localStorage.getItem('initdevice==')) {
    data.duid = JSON.parse(encipher.des_decrypt(localStorage.getItem('initdevice=='))).duid
  }
  let reqData = sortObjByKey(data)
  // 遍历reqData，去除sign用新变量tmpStr接
  let tmpStr = ''
  for (const key in reqData) {
    let tmp = ''
    if (key !== 'sign' && key !== 'token' && key !== 'comment' && key !== 'content') {
      if (reqData[key]) {
        tmp = reqData[key]
      } else {
        reqData[key] = ''
      }
      tmpStr += key + '=' + tmp + '&'
    }
  }
  tmpStr = tmpStr.substr(0, tmpStr.length - 1) + 'Jp8vQOYckhhta20221121'
  reqData.sign = md5(tmpStr)
  return reqData
  // return getFormData(reqData);
}

export function integration(query) {
  const result = {}
  Object.keys(query).forEach((key) => {
    if (Array.isArray(query[key])) {
      result[key] = query[key][0]
    } else {
      result[key] = query[key]
    }
  })
  return result
}

// IP接口
export function IPInfoAPI() {
  return axios({
    url: '/init/ip/',
    method: 'post',
    data: ''
  })
}
//初始化激活接口
export function InitAPI(params) {
  return axios({
    url: '/init/index/',
    method: 'post',
    data: getFormData(params)
  })
}
// 登录接口
export function LoginAPI(params) {
  return axios({
    url: '/user/login/',
    method: 'post',
    data: getFormData(params)
  })
}
// token登录接口
export function TokenLoginAPI(params) {
  return axios({
    url: '/user/tokenLogin/',
    method: 'post',
    data: getFormData(params)
  })
}
// 登出接口
export function LogoutAPI(params) {
  return axios({
    url: '/user/loginout/',
    method: 'post',
    data: getFormData(params)
  })
}
// 充值档位列表接口
export function GetProductsListAPI(params) {
  return axios({
    url: '/pay/products/' + getParams(params),
    method: 'get'
  })
}
// 下单接口
export function CreateOrderAPI(params) {
  return axios({
    url: '/order/create',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取首页TOP文章列表接口
export function GetHomePublicListAPI(params) {
  return axios({
    url: '/home/publiclist' + getParams(params),
    method: 'get'
  })
}
// 获取特殊文章列表接口
export function GetHomeSpecialListAPI(params) {
  return axios({
    url: '/home/special' + getParams(params),
    method: 'get'
  })
}

// 获取首页活动列表接口
export function GetHomeActivityListAPI(params) {
  return axios({
    url: '/home/activity' + getParams(params),
    method: 'get'
  })
}

// 获取首页TOP6动态列表接口
export function GetHomeTopTrendsListAPI(params) {
  return axios({
    url: '/trends/toplist' + getParams(params),
    method: 'get'
  })
}

// 支付网关接口
export function PayConfirmAPI(params) {
  return axios({
    url: '/order/paygate',
    method: 'post',
    data: getFormData(params)
  })
}
export function GetNewsAPI(params) {
  return axios({
    url: '/home/notice/',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取用户详情接口
export function GetUserInfoAPI(params) {
  return axios({
    url: '/user/info/' + getParams(params),
    method: 'get'
  })
}
// 获取区服列表
export function GetServerListAPI(params) {
  return axios({
    url: '/game/serverlist/' + getParams(params),
    method: 'get'
  })
}
// 获取角色列表
export function GetGameRoleAPI(params) {
  return axios({
    url: '/game/role/' + getParams(params),
    method: 'get'
  })
}
// 邮箱下发验证码
export function GetEmailCodeAPI(params) {
  return axios({
    url: '/email/code/' + getParams(params),
    method: 'get'
  })
}

// 绑定邮箱校验验证码接口
export function GetBindEmailCodeAPI(params) {
  return axios({
    url: '/user/findPwd/',
    method: 'post',
    data: getFormData(params)
  })
}
// 绑定或更新当前角色
export function BindUserRoleAPI(params) {
  return axios({
    url: '/game/bindUserRole/',
    method: 'post',
    data: getFormData(params)
  })
}
// 换绑邮箱接口
export function UpdateEmailAPI(params) {
  return axios({
    url: '/account/upbindemailstep/',
    method: 'post',
    data: getFormData(params)
  })
}
// 重置密码接口
export function ResetPWDAPI(params) {
  return axios({
    url: '/account/resetpwd/',
    method: 'post',
    data: getFormData(params)
  })
}
// 账号查询接口
export function GetBindEmailAPI(params) {
  return axios({
    url: '/user/getEmail/' + getParams(params),
    method: 'get'
  })
}
// 余额查询接口
export function GetBalanceAPI(params) {
  return axios({
    url: '/account/getBillingAccount/' + getParams(params),
    method: 'get'
  })
}
// 充值列表接口
export function GetPayWayListAPI(params) {
  return axios({
    url: '/pay/waylist/' + getParams(params),
    method: 'get'
  })
}
// 储值记录接口
export function GetPayRecordListAPI(params) {
  return axios({
    url: '/pay/spreedlist/' + getParams(params),
    method: 'get'
  })
}
// 钱包花费接口
export function GetWalletSpendListAPI(params) {
  return axios({
    url: '/pay/balanceSpreedList/' + getParams(params),
    method: 'get'
  })
}
// 攻略列表接口
export function GetStrategyListAPI(params) {
  return axios({
    url: '/aricle/alllist/' + getParams(params),
    method: 'get'
  })
}
// 攻略详情接口
export function GetStrategyDetailAPI(params) {
  return axios({
    url: '/aricle/info/' + getParams(params),
    method: 'get'
  })
}
// 点赞接口
export function WalletUpLikeAPI(params) {
  return axios({
    // url: '/walkthrough/upLike/',
    url: '/aricle/upLike/',
    method: 'post',
    data: getFormData(params)
  })
}
// 点踩接口
export function WalletUpCombatAPI(params) {
  return axios({
    // url: '/walkthrough/upCombat/',
    url: '/aricle/upCombat/',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取头像
export function GetHeadIconAPI(params) {
  return axios({
    url: '/account/getHeadImgList/' + getParams(params),
    method: 'get'
  })
}
// 获取头像框
export function GetHeadFrameAPI(params) {
  return axios({
    url: '/account/getHeadFrameList/' + getParams(params),
    method: 'get'
  })
}
// 获取称号
export function GetTitleAPI(params) {
  return axios({
    url: '/account/getTitle/' + getParams(params),
    method: 'get'
  })
}
// 设置用户头像
export function SetHeadIconAPI(params) {
  return axios({
    url: '/account/set/',
    method: 'post',
    data: getFormData(params)
  })
}
// 分享信息接口
export function GetShareInfoAPI(params) {
  return axios({
    url: '/share/index/' + getParams(params),
    method: 'get'
  })
}
//  确认分享接口
export function ConfigShareAPI(params) {
  return axios({
    url: '/share/click/',
    method: 'post',
    data: getFormData(params)
  })
}
// 发表评论接口
export function SubmitCommentAPI(params) {
  return axios({
    // url: '/reply/comment/',
    url: '/newreply/comment/',
    method: 'post',
    data: getFormData(params)
  })
}
// 主评论列表接口
export function GetCommentListAPI(params) {
  return axios({
    // url: '/reply/alllist/' + getParams(params),
    url: '/newreply/alllist/' + getParams(params),
    method: 'get'
  })
}
// 更多评论列表
export function GetMoreCommentListAPI(params) {
  return axios({
    // url: '/reply/moreList/' + getParams(params),
    url: '/newreply/moreList/' + getParams(params),
    method: 'get'
  })
}
// 评论点赞接口
export function UpCommentLikeAPI(params) {
  return axios({
    url: '/newreply/upLike/',
    method: 'post',
    data: getFormData(params)
  })
}
// 评论点踩接口
export function UpCommentCombatAPI(params) {
  return axios({
    url: '/newreply/upCombat/',
    method: 'post',
    data: getFormData(params)
  })
}
// 订单结果查询
export function GetPayResultAPI(params) {
  return axios({
    url: '/apple/search/' + getParams(params),
    method: 'get'
  })
}
// 获取轮播图
export function GetBannerAPI(params) {
  return axios({
    url: '/walkthrough/banner/' + getParams(params),
    method: 'get'
  })
}
// 获取关键词
export function GetHotWordAPI(params) {
  return axios({
    url: '/walkthrough/hot/' + getParams(params),
    method: 'get'
  })
}
// 收藏文章列表
export function GetArticleCollectListAPI(params) {
  return axios({
    url: '/account/userfocuslist/' + getParams(params),
    method: 'get'
  })
}
// 文章收藏变动接口
export function UpArticleCollectAPI(params) {
  return axios({
    // url: '/walkthrough/upfocus/',
    url: '/aricle/upfocus/',
    method: 'post',
    data: getFormData(params)
  })
}
// 绑定邮箱接口
export function BindemailAPI(params) {
  return axios({
    url: '/account/bindemail/',
    method: 'post',
    data: getFormData(params)
  })
}
// 苹果内购发货接口
export function AppleSendAPI(params) {
  return axios({
    url: '/apple/sdksend/',
    method: 'post',
    data: getFormData(params)
  })
}
// 安卓发货接口
export function GoogleSendAPI(params) {
  return axios({
    url: '/google/sdksend/',
    method: 'post',
    data: getFormData(params)
  })
}
// 行为上报接口
export function BehaviorEventAPI(params) {
  return axios({
    url: '/sdk/event/',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取抽奖配置信息接口
export function GetLotteryIndexAPI(params) {
  return axios({
    url: '/lottery/index' + getParams(params),
    method: 'get'
  })
}
// 获取用户抽奖明细接口
export function GetLotteryRecordsAPI(params) {
  return axios({
    url: '/lottery/records' + getParams(params),
    method: 'get'
  })
}
// 用户抽奖接口
export function LotteryDrawAPI(params) {
  return axios({
    url: '/lottery/draw',
    method: 'post',
    data: getFormData(params)
  })
}
// 侧边导航栏按钮
export function GetMenuListAPI(params) {
  return axios({
    // url: '/init/nav/' + getParams(params),
    url: '/init/newnav/' + getParams(params),
    method: 'get'
  })
}
// 代金券列表接口
export function GetVoucherListAPI(params) {
  return axios({
    url: '/account/voucherlist/' + getParams(params),
    method: 'get'
  })
}
// 攻略历史浏览记录
export function GetWalkthroughHistoryListAPI(params) {
  return axios({
    url: '/account/walkthroughhistorylist/' + getParams(params),
    method: 'get'
  })
}
// 充值排行榜接口
export function GetPayRankListAPI(params) {
  return axios({
    url: '/pay/rank' + getParams(params),
    method: 'get'
  })
}
// 获取指定账号详情接口
export function GetOhterUserInfoAPI(params) {
  return axios({
    url: '/user/showinfo' + getParams(params),
    method: 'get'
  })
}
// 获取用户动态列表接口
export function GetUserTrendsListAPI(params) {
  return axios({
    url: '/trends/alllist' + getParams(params),
    method: 'get'
  })
}
// 获取用户动态详情接口
export function GetUserTrendsInfoAPI(params) {
  return axios({
    url: '/trends/info' + getParams(params),
    method: 'get'
  })
}
// 用户删除动态接口
export function DeleteTrendsAPI(params) {
  return axios({
    url: '/trends/del',
    method: 'post',
    data: getFormData(params)
  })
}
// 用户动态点赞接口
export function upLikeTrendsAPI(params) {
  return axios({
    url: '/trends/upLike',
    method: 'post',
    data: getFormData(params)
  })
}
// 用户动态分享接口
export function shareTrendsAPI(params) {
  return axios({
    url: '/trends/forward',
    method: 'post',
    data: getFormData(params)
  })
}
// 用户图片上传接口
export function UploadImageAPI(params) {
  return axios({
    url: '/init/uploadimg',
    method: 'post',
    data: getFormData(params)
  })
}
// 用户发帖(发动态)
export function AddTrendsAPI(params) {
  let comment = params.comment;
  delete params.comment; // 先剔除，不参与签名计算
  
  let req = getReqData(params)
  
  // 签名之后，我们需要把 comment 加回到 FormData 中
  let formData = getFormData(req)
  formData.append('comment', comment) // 直接追加到最终的 FormData 里
  
  return axios({
    url: '/trends/add',
    method: 'post',
    data: formData
  })
}
// 获取首页分类接口
export function GetHomeCategoryAPI(params) {
  return axios({
    url: '/home/category' + getParams(params),
    method: 'get'
  })
}
// 用户提交反馈接口
export function AddFeedbackAPI(params) {
  return axios({
    url: '/account/add_suggestion',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取FAQ常见问题列表接口
export function GetFaqListAPI(params) {
  return axios({
    url: '/home/faqlist' + getParams(params),
    method: 'get'
  })
}
// 动态请求API
export function GetChangeInfoAPI(url, params) {
  if (url.includes('?')) {
    return axios({
      url: url + getParamsSpecial(params),
      method: 'get'
    })
  } else {
    return axios({
      url: url + getParams(params),
      method: 'get'
    })
  }
}

// 获取指定用户详情接口
export function GetAppointUserInfoAPI(params) {
  return axios({
    url: '/user/showinfo' + getParams(params),
    method: 'get'
  })
}
// 关注状态更新接口
export function UpFollowAPI(params) {
  return axios({
    url: '/userfriends/upfocus',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取用户关注/粉丝列表接口
export function GetUserFriendsAPI(params) {
  return axios({
    url: '/userfriends/alllist' + getParams(params),
    method: 'get'
  })
}
// 用户投稿接口
export function AddContributeAPI(params) {
  return axios({
    url: '/aricle/add',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取投稿内容列表接口
export function GetUserContributeAPI(params) {
  return axios({
    url: '/aricle/alllist' + getParams(params),
    method: 'get'
  })
}
// 动态收藏变动接口
export function UpTrendsCollectAPI(params) {
  return axios({
    // url: '/walkthrough/upfocus/',
    url: '/trends/upfocus/',
    method: 'post',
    data: getFormData(params)
  })
}
// 消息界面数据接口
export function GetTidingsInfoAPI(params) {
  return axios({
    url: '/message/index' + getParams(params),
    method: 'get'
  })
}
// 查看消息分类列表接口
export function GetTidingsSortListAPI(params) {
  return axios({
    url: '/message/alllist' + getParams(params),
    method: 'get'
  })
}
// 用户投稿列表接口
export function GetWorksListAPI(params) {
  return axios({
    url: '/aricle/myContribute' + getParams(params),
    method: 'get'
  })
}
// 账号注册接口
export function UserRegisterAPI(params) {
  return axios({
    url: '/user/reg',
    method: 'post',
    data: getFormData(params)
  })
}
// 代金券列表
export function GetVoucherListNewUserAPI(params) {
  return axios({
    url: '/activity/voucherlist/' + getParams(params),
    method: 'get'
  })
}
// 领取代金券接口
export function ReceiveGiftNewAPI(params) {
  return axios({
    url: '/activity/receivegift',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取弹窗列表接口
export function GetTChuangListAPI(params) {
  return axios({
    url: '/adv/alllist' + getParams(params),
    method: 'get'
  })
}
// 点击广告接口
export function CilckADAPI(params) {
  return axios({
    url: '/adv/click',
    method: 'post',
    data: getFormData(params)
  })
}
// 用户签到配置接口
export function GetSignConfigAPI(params) {
  return axios({
    url: '/sign/config' + getParams(params),
    method: 'get'
  })
}
// 用户签到数据接口
export function GetSignDataAPI(params) {
  return axios({
    url: '/sign/getUserRecord' + getParams(params),
    method: 'get'
  })
}
// 用户补签卡列表接口
export function GetSignSupplementDataAPI(params) {
  return axios({
    url: '/sign/getResignCard' + getParams(params),
    method: 'get'
  })
}
// 用户签到接口
export function UserSignAPI(params) {
  return axios({
    url: '/sign/usign',
    method: 'post',
    data: getFormData(params)
  })
}
// 用户补签接口
export function UserSupplementSignAPI(params) {
  return axios({
    url: '/sign/resign',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取用户余额接口
export function GetBillingAccountDataAPI(params) {
  return axios({
    url: '/account/getBillingAccountNew' + getParams(params),
    method: 'get'
  })
}
// 获取任务列表接口
export function GetTaskListAPI(params) {
  return axios({
    url: '/task/index' + getParams(params),
    method: 'get'
  })
}
// 领取任务及完成接口
export function CompleteTaskAPI(params) {
  return axios({
    url: '/task/complete',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取用户积分明细接口
export function GetIntegralRecordsAPI(params) {
  return axios({
    url: '/integral/records' + getParams(params),
    method: 'get'
  })
}
// 获取积分档位列表接口
export function GetPointsProductsDataAPI(params) {
  return axios({
    url: '/integral/products' + getParams(params),
    method: 'get'
  })
}
// 用户积分下单接口
export function UserCreatePointsOrderAPI(params) {
  return axios({
    url: '/integral/create',
    method: 'post',
    data: getFormData(params)
  })
}
// 用户确认积分订单接口
export function UserConfrimPointsOrderAPI(params) {
  return axios({
    url: '/integral/confrim',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取加入的频道列表接口
export function GetChannelListDataAPI(params) {
  return axios({
    url: '/account/my_channel' + getParams(params),
    method: 'get'
  })
}
// 获取加入的频道列表接口
export function GetTalkListAPI(params) {
  return axios({
    url: '/topic/alllist' + getParams(params),
    method: 'get'
  })
}
// 获取话题详情接口
export function GetTalkInfoAPI(params) {
  return axios({
    url: '/topic/info' + getParams(params),
    method: 'get'
  })
}
// 用户关注话题接口
export function UserFollowTopicAPI(params) {
  return axios({
    url: '/topic/upfocus',
    method: 'post',
    data: getFormData(params)
  })
}
// 获取频道邀请信息接口
export function GetChannelInviteInfoAPI(params) {
  return axios({
    url: '/share/channel_invite' + getParams(params),
    method: 'get'
  })
}
// 获取频道详情信息接口
export function GetChannelInfoAPI(params) {
  return axios({
    url: '/channel/info' + getParams(params),
    method: 'get'
  })
}
// 用户清除信息接口
export function ReadAllMessageAPI(params) {
  return axios({
    url: '/message/readAllMessage',
    method: 'post',
    data: getFormData(params)
  })
}
